import { render, staticRenderFns } from "./IndividualAccountEdit.vue?vue&type=template&id=0db8f928&scoped=true"
import script from "./IndividualAccountEdit.vue?vue&type=script&lang=js"
export * from "./IndividualAccountEdit.vue?vue&type=script&lang=js"
import style0 from "./IndividualAccountEdit.vue?vue&type=style&index=0&id=0db8f928&prod&lang=css"
import style1 from "./IndividualAccountEdit.vue?vue&type=style&index=1&id=0db8f928&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db8f928",
  null
  
)

export default component.exports